import { render, staticRenderFns } from "./temporaryClosure.vue?vue&type=template&id=72056b43&scoped=true"
import script from "./temporaryClosure.vue?vue&type=script&lang=js"
export * from "./temporaryClosure.vue?vue&type=script&lang=js"
import style0 from "./temporaryClosure.vue?vue&type=style&index=0&id=72056b43&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72056b43",
  null
  
)

export default component.exports